import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Flame } from "lucide-react";
import { T } from "../context/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const fmt = (n) => (n >= 1000 ? `${(n / 1000).toFixed(1)}k` : n);

const typeColor = {
  Sport: "bg-blue-100 text-blue-700",
  Team: "bg-purple-100 text-purple-700",
  City: "bg-emerald-100 text-emerald-700",
  League: "bg-orange-100 text-orange-700",
};

export const TrendingStrip = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/trending`).then((r) => setItems(r.data)).catch(() => {});
  }, []);

  if (!items.length) return null;

  return (
    <section className="border-y border-orange-100 bg-orange-50/60" data-testid="trending-strip">
      <div className="mx-auto flex max-w-[1400px] items-center gap-3 overflow-x-auto px-4 py-3 sm:px-6">
        <span className="flex shrink-0 items-center gap-1.5 text-sm font-extrabold text-orange-600">
          <Flame className="h-4 w-4" /> <T>Trending This Week</T>
        </span>
        {items.map((it) => (
          <Link
            key={it.key}
            to={it.link}
            data-testid={`trending-item-${it.key}`}
            className="flex shrink-0 items-center gap-2 rounded-full border border-slate-200 bg-white px-3.5 py-1.5 transition-all hover:-translate-y-0.5 hover:border-orange-400"
          >
            <span className="text-sm font-bold text-slate-800">{it.name}</span>
            <span className={`rounded-full px-2 py-0.5 text-[10px] font-bold uppercase ${typeColor[it.type] || "bg-slate-100 text-slate-600"}`}>{it.type}</span>
            <span className="text-xs font-semibold text-slate-400">{fmt(it.views)} <T>views</T></span>
          </Link>
        ))}
        <Link to="/digest" data-testid="weekly-digest-link" className="shrink-0 rounded-full bg-orange-500 px-4 py-1.5 text-sm font-bold text-white transition-colors hover:bg-orange-600">
          <T>Weekly Digest</T> →
        </Link>
      </div>
    </section>
  );
};
